import './styles.css';
import { useTranslation } from 'react-i18next';

export const ServiceDescription = ({ title, description }: { title: string; description: string }) => {
  const { t } = useTranslation();
  return (
    <div className="serviceDescription">
      <h1>{t(title)}</h1>
      <p>{t(description)}</p>
    </div>
  );
};

export default ServiceDescription;
